import * as React from "react"
import PlusContainer from "./mobile/PlusContainer"
import Animator from "./mobile/AnimatorSwiper"
import styled from "@emotion/styled"
import { Global, css } from "@emotion/react"
import { rr, theme } from "../styles/styleGuide"
import OrientationIcon from "../assets/mobile/svg/orientation.inline.svg"

const Loading: React.FC = () => {
  const Signature = styled.div`
    position: absolute;
    width: 120vw;
    height: 100%;
    background-color: #000;
    /* clip-path: inset(0% 0% 0% 0%); */
  `
  const Loading = styled.div`
    /* position: absolute; */
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: #000;
    width: 100vw;
    height: 100%;
    overflow: hidden;

    .sk-cube-grid {
      width: 40px;
      height: 40px;
      margin: 100px auto;
    }

    .sk-cube-grid .sk-cube {
      width: 33%;
      height: 33%;
      background-color: #ffffff;
      float: left;
      -webkit-animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
      animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
    }
    .sk-cube-grid .sk-cube1 {
      -webkit-animation-delay: 0.2s;
      animation-delay: 0.2s;
    }
    .sk-cube-grid .sk-cube2 {
      -webkit-animation-delay: 0.3s;
      animation-delay: 0.3s;
    }
    .sk-cube-grid .sk-cube3 {
      -webkit-animation-delay: 0.4s;
      animation-delay: 0.4s;
    }
    .sk-cube-grid .sk-cube4 {
      -webkit-animation-delay: 0.1s;
      animation-delay: 0.1s;
    }
    .sk-cube-grid .sk-cube5 {
      -webkit-animation-delay: 0.2s;
      animation-delay: 0.2s;
    }
    .sk-cube-grid .sk-cube6 {
      -webkit-animation-delay: 0.3s;
      animation-delay: 0.3s;
    }
    .sk-cube-grid .sk-cube7 {
      -webkit-animation-delay: 0s;
      animation-delay: 0s;
    }
    .sk-cube-grid .sk-cube8 {
      -webkit-animation-delay: 0.1s;
      animation-delay: 0.1s;
    }
    .sk-cube-grid .sk-cube9 {
      -webkit-animation-delay: 0.2s;
      animation-delay: 0.2s;
    }
    @-webkit-keyframes sk-cubeGridScaleDelay {
      0%,
      70%,
      100% {
        -webkit-transform: scale3D(1, 1, 1);
        transform: scale3D(1, 1, 1);
      }
      35% {
        -webkit-transform: scale3D(0, 0, 1);
        transform: scale3D(0, 0, 1);
      }
    }
    @keyframes sk-cubeGridScaleDelay {
      0%,
      70%,
      100% {
        -webkit-transform: scale3D(1, 1, 1);
        transform: scale3D(1, 1, 1);
      }
      35% {
        -webkit-transform: scale3D(0, 0, 1);
        transform: scale3D(0, 0, 1);
      }
    }
  `

  const Holder = styled.div`
    position: fixed;
    z-index: 1000;
    /* background-color: #000; */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100vw;
    /* clip-path: inset(0% 0% 0% 0%); */
    /* ${rr("height", "vh", 100)} */
    height: 100%;
  `
  return (
    <Holder id="loading">
      <Signature id="signature" />
      <Loading className="loading">
        <div className="sk-cube-grid">
          <div className="sk-cube sk-cube1"></div>
          <div className="sk-cube sk-cube2"></div>
          <div className="sk-cube sk-cube3"></div>
          <div className="sk-cube sk-cube4"></div>
          <div className="sk-cube sk-cube5"></div>
          <div className="sk-cube sk-cube6"></div>
          <div className="sk-cube sk-cube7"></div>
          <div className="sk-cube sk-cube8"></div>
          <div className="sk-cube sk-cube9"></div>
        </div>
      </Loading>
    </Holder>
  )
}
const Orientation = () => {
  React.useEffect(() => {
    var luanched = false
    if (window.innerWidth < window.innerHeight) {
      luanched = true
    }
    window.addEventListener("orientationchange", () => {
      console.log("changee")
      if (window.innerWidth < window.innerHeight) {
        // console.log("Landscape")
      } else {
        // console.log("Portrait")
        if (!luanched) {
          window.location.reload()
        }
      }
    })
  }, [])
  const Text = styled.h1`
    font-size: 4vw;
    width: 30vw;
    white-space: wrap;
    text-align: left;
    margin: 5vw;
    color: ${theme.color.yellow};
    ${theme.font.content.bold}
  `
  const Icon = styled.div`
    margin: 5vw;
    svg {
      width: 30vw;
    }
  `
  const Holder = styled.div`
    position: fixed;
    z-index: 3000;
    width: 100vw;
    ${rr("height", "vh", 100)}
    flex-direction: row;
    align-items: center;
    background-color: ${theme.color.black};
    justify-content: center;
    @media (orientation: landscape) {
      display: flex;
      pointer-events: all;
      &.on-Typing {
        display: none;
        pointer-events: none;
      }
    }
    @media (orientation: portrait) {
      display: none;
      pointer-events: none;
    }
  `
  return (
    <Holder id="orientation">
      <Text>Please Rotate Your Device</Text>
      <Icon>
        <OrientationIcon />
      </Icon>
    </Holder>
  )
}
function Mobile() {
  // if (isBrowser) {
  //   var userAgent = window.navigator.userAgent
  //   var md = new MobileDetect(userAgent)
  //   isMobile = md.mobile() != null
  //   if (isMobile) {
  //     import("../styles/mobile.css")
  //   }
  // }
  // window.onload = function () {
  //   gsap.to("#loading .acitve", { duration: 2, width: "100%", ease: "expo.in" })
  // }
  return (
    <>
      <Global
        styles={css`
          @import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&family=Staatliches&display=swap");

          :root {
            --device-height: 0px;
          }
          html {
            width: 100vw;
            height: var(--device-height);
            overflow: hidden;
            margin: 0;
            padding: 0;
          }

          body {
            margin: 0;
            padding: 0;
            width: 100vw;
            height: var(--device-height);
            box-sizing: content-box;
            overflow: hidden;
          }

          #___gatsby {
            position: relative;
            margin: 0;
            padding: 0;
            width: 100vw;
            height: var(--device-height);
            overflow: hidden;
            box-sizing: content-box;
          }
        `}
      />
      <Orientation />
      <Loading>
        <div className="sk-cube-grid">
          <div className="sk-cube sk-cube1"></div>
          <div className="sk-cube sk-cube2"></div>
          <div className="sk-cube sk-cube3"></div>
          <div className="sk-cube sk-cube4"></div>
          <div className="sk-cube sk-cube5"></div>
          <div className="sk-cube sk-cube6"></div>
          <div className="sk-cube sk-cube7"></div>
          <div className="sk-cube sk-cube8"></div>
          <div className="sk-cube sk-cube9"></div>
        </div>
      </Loading>
      <PlusContainer>
        <Animator />
      </PlusContainer>
      {/* <Test /> */}
    </>
  )
}

export default Mobile
